module.exports = __webpack_public_path__ + "static/media/settings-orange.9dbb69d3.svg";